/*
    模块组件
    ChenYN

    说明
    分享

    版本
    1.0

    传参
        showShare Boolean : 显示当前弹窗
        forumId Number : 举报时候需要用到的帖子id
        shareData Object : 分项数据
            shareData {
                icon String : 分享的图标
                link String :  分享的链接
                title String : 分享的标题
                desc String :  分享的描述
            }
        type String : 类型 game = 游戏分享; forum = 帖子分享
        reqCollect Function : 收藏和取消收藏按钮
        is_favor Boolean : 是否已经收藏
    依赖
    /style/2019/h5/css/common.css
    vue.js

    案例
        <share-popup :forumId="thread.tid" :showShare="showShare" @closeShare="showShare = false" :shareData="shareData" type="forum" :reqCollect="reqCollect" :is_favor="thread.user_like"></share-popup>
*/
<template>
    <div class="share_wrapper">
        <ShareSheet
            :show="showShare"
            :options="options"
            @cancel="closeShare"
            @click-overlay="closeShare"
            @select="onShareSelect"
            style="border-radius: 0.04rem 0.04rem 0 0"
        />
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, watch, onActivated, computed} from 'vue';
import router from "@/router";
import store from "@/store";
import { ShareSheet } from 'vant';
import NativeShare from 'nativeshare';
import Util from '@/assets/js/lib/util';
import qzone from "@/assets/images/common/share_qzone.png";
import jvbao from "@/assets/images/common/icon_jubaone.png";
import copy from "@/assets/images/common/icon_copy.png";
import logo from "@/assets/images/common/white_logo.png";
import collect from "@/assets/images/common/icon_collect.png";
import cancelCollect from "@/assets/images/common/icon_canCollect.png";

export default defineComponent({
    name: 'SharePopup',
    components: { ShareSheet },
    props: {
        showShare: {
            type: Boolean,
            default: false
        },
        shareData: {
            type: Object,
            default: {}
        },
        type: {
            type: String,
            default: 'game'
        },
        forumId: {
            type: Number,
            default: 0
        },
        reqCollect: {
            type: Function,
        },
        is_favor: {
            type: Boolean,
        }
    },
    setup(props, { emit }) {
        const state = reactive({
            options: [
                [
                    { name: '微博', target: 'weibo', icon: 'weibo' },
                    { name: 'QQ', target: 'qqFriend', icon: 'qq' },
                    { name: 'QQ空间', target: 'qZone', icon: qzone },
                    { name: '微信', target: 'wechatFriend', icon: 'wechat' },
                    { name: '朋友圈', target: 'wechatTimeline', icon: 'wechat-moments' },
                ],
            ],
            nativeShare: new NativeShare(),
            Util: new Util(),
            userVipInfo: computed(() => store.state.userVipInfo)
        });
        watch(() => props.type, () => {
            if(props.type == 'game'){
                state.options = [
                    [
                        { name: '微博', target: 'weibo', icon: 'weibo' },
                        { name: 'QQ', target: 'qqFriend', icon: 'qq' },
                        { name: 'QQ空间', target: 'qZone', icon: qzone },
                        { name: '微信', target: 'wechatFriend', icon: 'wechat' },
                        { name: '朋友圈', target: 'wechatTimeline', icon: 'wechat-moments' },
                    ],
                ]
            }else{
                if(props.is_favor){
                    state.options = [
                        [
                            { name: '微博', target: 'weibo', icon: 'weibo' },
                            { name: 'QQ', target: 'qqFriend', icon: 'qq' },
                            { name: 'QQ空间', target: 'qZone', icon: qzone },
                            { name: '微信', target: 'wechatFriend', icon: 'wechat' },
                            { name: '朋友圈', target: 'wechatTimeline', icon: 'wechat-moments' },
                        ],
                        [
                            { name: '取消收藏', target: 'cancelCollect', icon: cancelCollect },
                            { name: '举报', target: 'jvbao', icon: jvbao },
                            { name: '复制链接', target: 'copy', icon: copy },
                        ],
                    ]
                }else{
                    state.options = [
                        [
                            { name: '微博', target: 'weibo', icon: 'weibo' },
                            { name: 'QQ', target: 'qqFriend', icon: 'qq' },
                            { name: 'QQ空间', target: 'qZone', icon: qzone },
                            { name: '微信', target: 'wechatFriend', icon: 'wechat' },
                            { name: '朋友圈', target: 'wechatTimeline', icon: 'wechat-moments' },
                        ],
                        [
                            { name: '收藏', target: 'collect', icon: collect },
                            { name: '举报', target: 'jvbao', icon: jvbao },
                            { name: '复制链接', target: 'copy', icon: copy },
                        ],
                    ]
                }

            }
        });

        watch(() => props.shareData, (newVal, oldVal) => {
            // if(newVal.title != "" && newVal.title != oldVal.title){
            //     methods.getWXData();
            // }
        });

        watch(()=>props.is_favor, ()=>{
                if(props.is_favor){
                    state.options = [
                        [
                            { name: '微博', target: 'weibo', icon: 'weibo' },
                            { name: 'QQ', target: 'qqFriend', icon: 'qq' },
                            { name: 'QQ空间', target: 'qZone', icon: qzone },
                            { name: '微信', target: 'wechatFriend', icon: 'wechat' },
                            { name: '朋友圈', target: 'wechatTimeline', icon: 'wechat-moments' },
                        ],
                        [
                            { name: '取消收藏', target: 'cancelCollect', icon: cancelCollect },
                            { name: '举报', target: 'jvbao', icon: jvbao },
                            { name: '复制链接', target: 'copy', icon: copy },
                        ],
                    ]
                }else{
                    state.options = [
                        [
                            { name: '微博', target: 'weibo', icon: 'weibo' },
                            { name: 'QQ', target: 'qqFriend', icon: 'qq' },
                            { name: 'QQ空间', target: 'qZone', icon: qzone },
                            { name: '微信', target: 'wechatFriend', icon: 'wechat' },
                            { name: '朋友圈', target: 'wechatTimeline', icon: 'wechat-moments' },
                        ],
                        [
                            { name: '收藏', target: 'collect', icon: collect },
                            { name: '举报', target: 'jvbao', icon: jvbao },
                            { name: '复制链接', target: 'copy', icon: copy },
                        ],
                    ]
                }
        })

        const data = reactive({});
        const methods = {
            back: () => route.back(),
            goState: (o) => router.push(o),
            closeShare: () => {
                emit('closeShare')
            },
            onShareSelect: (option) => {
                methods.closeShare()
                if(option.target == 'jvbao'){
                    methods.goState({
                        name: 'complaint',
                        params: {
                            type: 'forum',
                            id: props.forumId
                        }
                    });
                    return false;
                }else if(option.target == 'collect'){
                    console.log(123456789)
                    if (!state.Util.getCookieLocalStorage('access_token')) {
                        state.Util.login({ query: { routerurl: router?.options?.history?.state?.current } }, 'replace')
                        return false;
                    }
                    props.reqCollect();
                    return false;
                }else if(option.target == 'cancelCollect'){
                    props.reqCollect();
                    return false;
                }else if(option.target == 'copy') {
                    console.log('点击了复制按钮', window.location.href)
                    methods.copyTextToClipboard(window.location.href).then(success => {
                        if(success) {
                            window.Components.toast('复制成功')
                        }
                    })
                    return false;
                }

                //分享埋点
                shareThread();

                // 设置分享文案
                state.nativeShare.setShareData({
                    icon: props.shareData.icon || window.location.origin + logo,
                    link: props.shareData.link || window.location.href,
                    title: props.shareData.title || '',
                    desc: props.shareData.desc || ''
                })
                // 唤起浏览器原生分享组件(如果在微信中不会唤起，此时call方法只会设置文案。类似setShareData)
                try {
                    state.nativeShare.call(option.target ? option.target : 'default');
                } catch(err) {
                    // 如果不支持，你可以在这里做降级处理
                    window.Components.toast('不支持该浏览器自动分享,请您手动分享')
                }

                let isWX = navigator.userAgent.toLowerCase().match(/MicroMessenger/i)=="micromessenger";
                if(Boolean(isWX)){
                    window.Components.toast('请点击顶部导航栏“···”进行分享')
                    return false
                }

                state.showShare = false;
            },
            getWXData: async () => {
                var wxData = {
                    title: props.shareData.title || '',
                    link: props.shareData.link || window.location.href,
                    imgUrl: props.shareData.icon || window.location.origin + logo,
                    desc: props.shareData.desc || ''
                };// 要分享的内容

                const res = await state.Util.getJson('/common/wxInfo', 'GET', {referer_url: encodeURIComponent(wxData.link)}, true);
                if(res.code == 1){
                    wx.config({
                        debug: false,
                        appId: res.data.sign_package.appId,
                        timestamp: res.data.sign_package.timestamp,
                        nonceStr: res.data.sign_package.nonceStr,
                        signature: res.data.sign_package.signature,
                        jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"]
                    });

                    wx.ready(function() {
                        //需在用户可能点击分享按钮前就先调用
                        wx.onMenuShareTimeline({
                            //分享朋友圈
                            title: wxData.title, // 分享标题
                            link: wxData.link, // 分享链接
                            imgUrl: wxData.imgUrl, // 分享图标
                            desc: state.Util.removeHtml(wxData.desc) || '', // 分享描述
                            complete: function() {
                                window.Components.toast("分享朋友圈成功！");
                            }
                        });

                        wx.onMenuShareAppMessage({
                            //分享好友
                            title: wxData.title, // 分享标题
                            link: wxData.link, // 分享链接
                            imgUrl: wxData.imgUrl, // 分享图标
                            desc: state.Util.removeHtml(wxData.desc) || '', // 分享描述
                            complete: function() {
                                window.Components.toast("分享好友成功！");
                            }
                        });
                    });
                }else {
                    console.log(res.msg);
                }
            },
            copyTextToClipboard: (text) => {
                // 判断是否为iOS设备
                const isIOS = /iPad|iPhone|iPod|Macintosh/i.test(navigator.userAgent);

                // 方案1：在iOS设备上尝试使用现代的Clipboard API
                if (isIOS && navigator.clipboard && navigator.clipboard.writeText) {
                    return navigator.clipboard.writeText(text)
                    .then(() => {
                        console.log('使用Clipboard API复制成功！');
                        return true;
                    })
                    .catch(err => {
                        console.warn('Clipboard API复制失败，降级到传统方法', err);
                        return methods.fallbackCopyText(text); // 降级方案
                    });
                } else {
                    // 方案2：安卓或其他情况，直接使用传统备选方案
                    return methods.fallbackCopyText(text);
                }
            },
            // 传统的备选复制方案
            fallbackCopyText: (text) => {
                return new Promise((resolve) => {
                    // 创建一个临时的textarea元素
                    const textArea = document.createElement('textarea');
                    textArea.value = text;
                    textArea.setAttribute('readonly', ''); // 设置为只读，防止弹出键盘
                    textArea.style.position = 'absolute';
                    textArea.style.left = '-9999px'; // 移到屏幕外
                    document.body.appendChild(textArea);

                    // 选择文本（兼容iOS需要特殊处理）
                    if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
                        const range = document.createRange();
                        range.selectNodeContents(textArea);
                        const selection = window.getSelection();
                        selection.removeAllRanges();
                        selection.addRange(range);
                        textArea.setSelectionRange(0, 999999); // 设置一个大的选择范围
                    } else {
                        textArea.select(); // 标准选择方法
                    }

                    try {
                        const successful = document.execCommand('copy');
                        document.body.removeChild(textArea); // 清理DOM
                    if (successful) {
                        console.log('使用execCommand复制成功！');
                        resolve(true);
                    } else {
                        throw new Error('execCommand failed');
                    }
                    } catch (err) {
                        console.error('两种复制方法都失败了:', err);
                        // 终极备选方案：提示用户手动复制

                        window.Components.toast('自动复制失败，请手动复制以下链接：', text);
                        resolve(false);
                    }
                });
            }
        }; //需要对外暴露的方法

        onMounted(() => {
            if(props.type == 'game'){
                state.options = [
                    [
                        { name: '微博', target: 'weibo', icon: 'weibo' },
                        { name: 'QQ', target: 'qqFriend', icon: 'qq' },
                        { name: 'QQ空间', target: 'qZone', icon: qzone },
                        { name: '微信', target: 'wechatFriend', icon: 'wechat' },
                        { name: '朋友圈', target: 'wechatTimeline', icon: 'wechat-moments' },
                    ],
                ]
            }else{
                if(props.is_favor){   //如果收藏了，就是显示取消收藏按钮
                    state.options = [
                        [
                            { name: '微博', target: 'weibo', icon: 'weibo' },
                            { name: 'QQ', target: 'qqFriend', icon: 'qq' },
                            { name: 'QQ空间', target: 'qZone', icon: qzone },
                            { name: '微信', target: 'wechatFriend', icon: 'wechat' },
                            { name: '朋友圈', target: 'wechatTimeline', icon: 'wechat-moments' },
                        ],
                        [
                            { name: '取消收藏', target: 'cancelCollect', icon: cancelCollect },
                            { name: '举报', target: 'jvbao', icon: jvbao },
                        ],
                    ]
                }else{
                    state.options = [
                        [
                            { name: '微博', target: 'weibo', icon: 'weibo' },
                            { name: 'QQ', target: 'qqFriend', icon: 'qq' },
                            { name: 'QQ空间', target: 'qZone', icon: qzone },
                            { name: '微信', target: 'wechatFriend', icon: 'wechat' },
                            { name: '朋友圈', target: 'wechatTimeline', icon: 'wechat-moments' },
                        ],
                        [
                            { name: '收藏', target: 'collect', icon: collect },
                            { name: '举报', target: 'jvbao', icon: jvbao },
                        ],
                    ]
                }
            }
        });

        const shareThread = async() => { //分享帖子
            const res = await state.Util.getJson('/benefit/shareThread', 'GET', { user_id: state.userVipInfo.uid, tid: props.forumId}, true);
            if(res.code == 0){
            }else {
                window.Components.toast(res.message)
            }
        };

        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods
        };
    },
});
</script>
<style lang="less" scoped>
@charset "utf-8";
@import "./SharePopup.less";
</style>